import { useEffect } from "react";
import { navigate, setQuery, useRoute } from "../lib/router";
import { useSession } from "../lib/session";
import { Seg } from "../components/ui";
import Dashboards from "./leads/Dashboards";
import Reports from "./leads/Reports";
import Funnel from "./leads/Funnel";
import TeamDashboard from "./team/TeamDashboard";
import ActivityLog from "./ActivityLog";

type Tab = "scorecard" | "results" | "funnel" | "team" | "log";

/** One place for every report: scorecard, month-by-month results, funnel and team. */
export default function ReportsHub() {
  const { query } = useRoute();
  const { can } = useSession();
  const tabs = ([
    can("dashboards") && { value: "scorecard", label: "Scorecard" },
    can("dashboards") && { value: "results", label: "Month by month" },
    can("dashboards") && { value: "funnel", label: "Funnel" },
    can("team") && { value: "team", label: "Team" },
    can("activities") && { value: "log", label: "Activity log" },
  ].filter(Boolean)) as { value: Tab; label: string }[];
  const tab = (tabs.find((t) => t.value === query.get("view"))?.value ?? tabs[0]?.value) as Tab | undefined;
  return (
    <>
      <div className="report-tabs"><Seg value={tab ?? "scorecard"} onChange={(v) => setQuery({ view: v })} options={tabs} /></div>
      {tab === "scorecard" && <Dashboards />}
      {tab === "results" && <Reports />}
      {tab === "funnel" && <Funnel />}
      {tab === "team" && <TeamDashboard />}
      {tab === "log" && <ActivityLog />}
    </>
  );
}

/** Old links (bookmarks, emails) land on the right place. */
export function Redirect({ to }: { to: string }) {
  useEffect(() => { navigate(to, { replace: true }); }, [to]);
  return null;
}
